import { useCallback, useEffect, useState } from "react";
import { api } from "@/api";

export function useFavorites() {
  const [favIds, setFavIds] = useState(new Set());

  const load = useCallback(async () => {
    try {
      const res = await api.get("/favorites/ids");
      setFavIds(new Set(res.data));
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const onToggleFav = useCallback((id, nowFav) => {
    setFavIds((prev) => {
      const next = new Set(prev);
      if (nowFav) next.add(id);
      else next.delete(id);
      return next;
    });
  }, []);

  return { favIds, onToggleFav, reloadFavorites: load };
}
